module Client.Components.ErrorConfirmation

open Browser
open Client.DomainTypes.Msg
open Elmish.SweetAlert
open Shared.Dto.Dto
open Elmish
open System

let defaultErrorMessage =
    "Beim Laden der Daten ist ein Fehler aufgetreten. Bitte lade die Seite neu. Wenn der Fehler bestehen bleibt, dann wende dich an einen Administrator"

type Handler<'a> = ConfirmAlertResult -> 'a

type Config<'a> = {
    Handler: Handler<'a>
    TimeoutMilliseconds: int
}

let confirmation (config: Config<'a>) (message: string) (canReload: bool) =
    if canReload then
        let confirmAlert =
            ConfirmAlert(message, config.Handler)
                .ShowCloseButton(true)
                .ConfirmButtonText("Seite neu laden")
                .ConfirmButton(true)
                .CancelButtonText("Abbrechen")
                .Type(AlertType.Error)

        SweetAlert.Run(confirmAlert)
    else
        let alert =
            SimpleAlert(message)
                .Type(AlertType.Error)
                .ConfirmButton(false)
                .Timeout(config.TimeoutMilliseconds)

        SweetAlert.Run(alert)

let responseError (config: Config<'a>) (responseError: AuthenticatedResponseError) : Cmd<'a> =
    let msg, reload =
        match responseError with
        | AuthErr Unauthenticated -> "Du wurdest automatisch ausgeloggt, bitte lade die Webseite neu", true
        | AuthErr Unauthorized ->
            "Du bist nicht dazu berechtigt, diese Daten abzufragen, bitte wende dich an einen Administrator", false
        | _ -> defaultErrorMessage, true

    confirmation config msg reload


let dataTransmissionErrorConfirmation (config: Config<'a>) (_: Exception) =
    confirmation config defaultErrorMessage true

let createHandler (f: bool -> 'a) (result: ConfirmAlertResult) =
    let reload =
        match result with
        | ConfirmAlertResult.Confirmed -> true
        | ConfirmAlertResult.Dismissed _ -> false

    f reload

let doReload (reload: bool) =
    if reload then window.location.reload true else ()

let defaultConfig = {
    Handler = createHandler (GlobalMsg.Reload >> Global)
    TimeoutMilliseconds = 5000
}